import { toast } from 'sonner';

/**
 * Surfaces an "out of credits" message with a one-tap path to the plans page.
 *
 * Used by both the Writer chat and the AI review entry points so the
 * treatment stays consistent. The backend returns HTTP 402 with
 * `{ error: 'insufficient_credits' }` from `generate-ai-review` and streams
 * `{ code: 'insufficient_credits' }` from `writer-agent`.
 */
export function showInsufficientCreditsToast(
  context: 'writing' | 'review' = 'review',
) {
  toast.error('You are out of credits', {
    description:
      context === 'writing'
        ? 'Your free credits are used up. Upgrade for more writing turns each month.'
        : 'Your free credits are used up. Upgrade for more AI reviews each month.',
    action: {
      label: 'View plans',
      onClick: () => {
        window.location.assign('/pricing');
      },
    },
    duration: 8000,
  });
}

/**
 * Extracts the `error` key from a Supabase FunctionsHttpError. The non-2xx
 * body is buried in `error.context` (a Response); this reads and JSON-parses
 * it, returning the `error` string field or `undefined`.
 */
export async function readFunctionErrorKey(error: unknown): Promise<string | undefined> {
  try {
    const ctx = (error as { context?: unknown }).context;
    if (ctx && typeof (ctx as Response).json === 'function') {
      const body = await (ctx as Response).json();
      return typeof body?.error === 'string' ? body.error : undefined;
    }
  } catch {
    // ignore parse failures
  }
  return undefined;
}
